import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { UserApi } from "../api-services/user.api";

export function AuthModal( { method })
{
    const user = UserApi();

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleInputs = ( event ) => {
        const { name , value } =  event.target ;
        setInputs( { ...inputs, [name] : value   } ) ;
    }
      
    const handleForm = async ( event ) => {
        event.preventDefault();
        // console.log(inputs);
        setStatus(0);
        setIsLoading(true);
        try {
            const res = await user.auth(inputs);
            setIsLoading(false);
            if( res.data.success ){
                setIsLoading(false);
                setStatus(1);
                localStorage.setItem("uid", res.data.uid);
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("fname", res.data.fname);
                localStorage.setItem("lname", res.data.lname);
                localStorage.setItem("email", res.data.email);
                localStorage.setItem("phone", res.data.phone);
                method ( false );
            }
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    } 

    return (

      <div className="modal-container">
        <div className="container pt-5">
          <div className="row d-flex justify-content-center mt-md-5 px-2">
            <div className="col-lg-7 bg-white py-5 d-flex flex-column rounded-3">
              <div className="text-end"> 
                <button className="btn-close btn-close-white position-absolute end-0 me-3" style={{ top: "10px" }} aria-label="Close" onClick={ ()=>{ method ( false ) } } ></button>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-lg-7 rounded-2 py-4 px-4">

                  <form onSubmit={ handleForm } className="d-flex flex-column">
                    <div className=" d-flex flex-column align-items-center gap-2 mb-4" > 
                      <img src="./favicon.png" alt="icon-agrospace" width="60" className=""/>
                      <span className="lead text-muted text-start"> Agrospace - connexion </span>
                    </div>
                    {
                      isLoading && (
                        <div className="d-flex justify-content-center align-items-center mb-3"> 
                          <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                        </div>
                      )
                    }
                    {
                      status === 1 && (
                        <div className="col-md-12 mb-2">
                          <div className="alert alert-success">
                            Authentifier avec succes.
                          </div>
                        </div>
                      )
                    }
                    {
                      status === -1 && (
                        <div className="col-md-12 mb-2">
                          <div className="alert alert-danger">
                            Erreur d'authentification. Assurer vous que votre compte et bien actif et rééssayer.
                          </div>
                        </div>
                      )
                    }
                    <input type="text" name="login" className="border text-muted p-3 rounded-2 mb-3" placeholder="Email ou numéro de téléphone" required onChange={ handleInputs } />
                    <input type="password" name="password" className="border text-muted p-3 rounded-2 mb-3" placeholder="Mot de passe" required onChange={ handleInputs } />
                             
                    <button type="submit" className="btn btn-lg btn-success px-4 mt-2"> Connexion </button> 

                    <div className="mt-4 text-muted text-center">──────── ou ────────</div>

                    <div className="d-flex gap-2 border rounded-2 py-2 px-4 text-outline-muted mt-4">
                      <span> Pas encore de compte : </span>
                      <a href="/inscription" className="nav-link text-success"> S'inscrire maintenant <i className="bi bi-arrow-right"></i></a>
                    </div>

                    <div className="d-flex gap-2 border rounded-2 py-2 px-4 text-outline-muted mt-3">
                      <span> Oublier mot de passe : </span>
                      <a href="/mot-de-passse" className="nav-link text-success" target="outlet" > Modifier içi <i className="bi bi-arrow-right"></i> </a>
                    </div>
                   
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}